import jwtDecode from 'jwt-decode'
import selector from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import initializeApp from 'utils/initializeApp'
import { startPresenceHeartbeat, stopPresenceHeartbeat } from 'utils/presenceHeartbeat'
import instRequest from 'utils/instRequest'
import request from 'utils/request'

export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const INSTITUTE_CAMPUS_ID = 'INSTITUTE_CAMPUS_ID'
export const INSTITUTE_DETAILS = 'INSTITUTE_DETAILS'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CITIES_LIST = 'SET_CITIES_LIST'
export const SET_COUNTRIES_LIST = 'SET_COUNTRIES_LIST'
export const SET_STATES_LIST = 'SET_STATES_LIST'
export const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'

export const SignInSuccess = token => {
  return {
    type: SIGN_IN_SUCCESS,
    token,
  }
}

export const SetInstituteCampusId = id => {
  return {
    type: INSTITUTE_CAMPUS_ID,
    id,
  }
}

export const SetInstituteDetails = data => {
  return {
    type: INSTITUTE_DETAILS,
    data,
  }
}

export const setUserRoleData = list => {
  return {
    type: SET_USER_ROLE,
    list,
  }
}

export const setUserId = id => {
  return {
    type: SET_USER_ID,
    id,
  }
}

export const setCurrentUserInfo = data => {
  return {
    type: SET_USER_INFO,
    data,
  }
}

export const setCountriesList = data => {
  return {
    type: SET_COUNTRIES_LIST,
    data,
  }
}

export const setStatesList = data => {
  return {
    type: SET_STATES_LIST,
    data,
  }
}

export const setCitiesList = data => {
  return {
    type: SET_CITIES_LIST,
    data,
  }
}

export const setUserNotifications = data => {
  return {
    type: SET_USER_NOTIFICATIONS,
    data,
  }
}

export const setCurrentUserPermissions = data => {
  return {
    type: SET_USER_PERMISSIONS,
    data,
  }
}

export const SignIn = token => async dispatch => {
  try {
    if (token) {
      localStorage.clear()
      const decodedToken = jwtDecode(token)
      initializeApp(token) // pass the token to this function
      startPresenceHeartbeat()
      dispatch(SignInSuccess(token))
      dispatch(SetInstituteCampusId(decodedToken?.user?.institute_id))
      dispatch(getInstituteDetails(decodedToken?.user?.institute_id))
      dispatch(setUserId(decodedToken?.user?._id))
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}

export const InstituteData = data => async dispatch => {
  dispatch(SetInstituteDetails(data))
}

export const getUserRoles = () => async (dispatch, getState) => {
  try {
    let response = await adminRequest.get(`/roles/journey/INSTITUTE`)
    dispatch(setUserRoleData(response?.data?.data))
  } catch (error) {
    console.error('Getting error in corporate data', error)
  }
}

export const getUserInfo = () => async (dispatch, getState) => {
  const state = getState()
  const userId = selector.getUserId(state)
  try {
    let resp = await request.get(`user/${userId}`)
    let userData = resp?.data?.data
    if (userData?.pluginlive_id) {
      let adminResp = await adminRequest.get(`users/${userData?.pluginlive_id}`)
      if (adminResp?.status == 200 || adminResp?.status == 201) {
        userData.admin = adminResp?.data?.data
      }
    }
    dispatch(setCurrentUserInfo(userData))
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}

export const getUserPermissions = roleId => async (dispatch, getState) => {
  try {
    let resp = await adminRequest.get(
      `roleEvents/${roleId}?journey=INSTITUTE&roleName=ADMIN`
    )
    dispatch(setCurrentUserPermissions(resp?.data?.data))
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}

export const getListOfCountries =
  ({ searchValue, pageLimit = 50, currentPage = 0, query = false }) =>
  async (dispatch, getState) => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''
    let key = query ? '&groupBy=phoneCode' : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/countries?pageLimit=${pageLimit}${searchKey}${key} `
      )
      dispatch(setCountriesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of countries.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getListOfStates =
  ({ searchValue, pageLimit = 50, currentPage = 0, countryId }) =>
  async (dispatch, getState) => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''
    let countryID = countryId ? `&countryId=${countryId}` : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/states?pageLimit=${pageLimit}${countryID}${searchKey}`
      )
      dispatch(setStatesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of states.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getListOfCities =
  ({ searchValue, pageLimit = 50, currentPage = 0, countryId, stateId }) =>
  async (dispatch, getState) => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''
    let countryID = countryId ? `&countryId=${countryId}` : ''
    let stateID = stateId ? `&stateId=${stateId}` : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/cities?pageLimit=${pageLimit}${countryID}${stateID}${searchKey}`
      )
      dispatch(setCitiesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of citites.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }
export const getUserNotifications =
  ({ userId, pageLimit = 20, currentPage = 1, isAction = false, setLoading }) =>
  async (dispatch, getState) => {
    try {
      setLoading(true)
      let response = await request.get(
        `/users/${userId}/notification?pageLimit=${pageLimit}&currentPage=${currentPage}&isAction=${isAction}`
      )
      dispatch(setUserNotifications(response?.data?.data || {})) // need to check after API available
      setLoading(false)
      return response
    } catch (error) {
      console.error('Getting error in user notification list =>', error)
      ErrorMessage(error?.response?.data?.message)
      setLoading(false)
      return error
    }
  }

export const getInstituteDetails =
  instituteId => async (dispatch, getState) => {
    try {
      const data = await instRequest.get(`institutes/${instituteId}`)
      if (data?.data?.data?.instituteCampus) {
        let instInfo = {
          ...data?.data?.data?.instituteCampus[0],
          tier: data?.data?.data?.tier,
        }
        dispatch(SetInstituteDetails(instInfo))
      }
    } catch (error) {}
  }
export const markNotificationReadApi =
  ({ userId, payload }) =>
  async (dispatch, getState) => {
    try {
      let response = await request.put(
        `/users/${userId}/notification/markasread`,
        payload
      )
      return response
    } catch (error) {
      console.error('Getting error in marking notification as read.', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const signOut = token => async dispatch => {
  try {
    stopPresenceHeartbeat()
    let response = await request.post(`users/signout`)
    if (response?.data?.message == 'Success') {
      SuccessMessage('Logged out successfully!')
      localStorage.clear()
      window.location.href = '/'
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}
export const checkOut = email => async (dispatch, getState) => {
  try {
    const state = getState()
    const internalId = selector.getUserInfo(state)?.pluginlive_id
    if (!internalId) {
      return ErrorMessage('Invalid USer')
    }
    let response = await request.post(`users/signout`)
    if (response?.status >= 200 && response?.status <= 300) {
      let journey = 'INTERNAL'
      let payLoad = {
        email,
        journey,
        journeyId: internalId,
      }
      try {
        const data = await request.post(`/user/portal/signin`, payLoad)

        if (data.status === 200) {
          SuccessMessage('Checkout out successfully!')

          let redirectLink =
            data?.data?.data?.redirectLink + '&landingPage=/institutes'
          if (redirectLink) {
            localStorage.clear()
            window.location.href = redirectLink
          }
        }
      } catch (error) {
        console.error('Getting error while checKout', error)
      }
    }
  } catch (error) {
    console.error('Getting error while logout', error)
  }
}
